import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModeService } from './mode.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly modeService: ModeService,
  ) { }

  async get<T>(waitFor: string, url: string): Promise<T | null> {
    return new Promise(resolve => {
      if (waitFor !== '') {
        this.modeService.addToWaitList(waitFor);
      }
      this.httpClient.get<T>(url).subscribe({
        next: result => {
          if (waitFor !== '') {
            this.modeService.removeFromWaitList(waitFor);
          }
          resolve(result);
        },
        error: error => {
          if (waitFor !== '') {
            alert(`Error while ${waitFor.toLowerCase()}`);
          } else {
            this.modeService.removeFromWaitList(waitFor);
            alert(`Error during API call.`);
          }
          resolve(null);
        }
      });
    });
  }

  async delete(waitFor: string, url: string): Promise<boolean> {
    return new Promise(resolve => {
      this.modeService.addToWaitList(waitFor);
      this.httpClient.delete<void>(url).subscribe({
        next: () => {
          this.modeService.removeFromWaitList(waitFor);
          resolve(true);
        },
        error: e => {
          console.log(e);
          this.modeService.removeFromWaitList(waitFor);
          resolve(false);
        }
      });
    });
  }

  async post<T1, T2>(waitFor: string, url: string, body: T2): Promise<T1 | null> {
    return new Promise(resolve => {
      this.modeService.addToWaitList(waitFor);
      this.httpClient.post<T1>(url, body).subscribe({
        next: (data: T1) => {
          this.modeService.removeFromWaitList(waitFor);
          resolve(data);
        },
        error: (e: any) => {
          console.log(e);
          this.modeService.removeFromWaitList(waitFor);
          alert(`Error while ${waitFor.toLowerCase()}`);
          resolve(null);
        }
      });
    });
  }
}
